module.exports = __webpack_public_path__ + "static/media/bi.9b802cca.svg";